import React from "react"
import ResourceBannerWithData from "../../components/ResourceBanner/ResourceBannerWithData"
import RoomStatusListWithControlsWithData from "../../components/RoomStatusListWithControls/RoomStatusListWithControlsWithData"

const HistoryView = props => {
  return (
    <div className="HistoryView content">
      <ResourceBannerWithData />
      <RoomStatusListWithControlsWithData />
    </div>
  )
}
export default HistoryView
